/*

m2g-order-section boilerplate

<div class="m2g-order-section">
    <div class="m2g-order-section-header">
        <span class="m2g-order-section-title"></span>
        <span data-order-section-status-icon class="m2g-order-section-status-icon m2g-icon"></span>
        <span data-order-section-status class="m2g-order-section-status"></span>
    </div>
</div>

*/
import jQuery from 'jquery';
import _ from 'lodash';

const UI = Mobi2Go.UI || {};

UI.OrderSection = function(el) {
    this.$element = jQuery(el);
    this.$status = this.$element.find('[data-order-section-status]');
    this.$status_icon = this.$element.find('[data-order-section-status-icon]');
};

_.extend(UI.OrderSection.prototype, {
    setStatus(html, icon) {
        this.$status.html(html || '');
        this.setStatusIcon(icon || '');
    },
    setStatusIcon(icon_class) {
        if (icon_class) {
            const class_name = `${'m2g-order-section-status-icon m2g-icon' +
                ' m2g-icon--'}${icon_class}`;
            this.$status_icon.attr('class', class_name);
        } else {
            this.$status_icon.attr('class', 'm2g-hidden');
        }
    },
    clearStatus() {
        this.setStatus('');
        this.setStatusIcon();
    },
    animateTitle() {
        this.$element.addClass('m2g-order-section--warning');
    },
    fade(is_faded) {
        this.$element[is_faded ? 'addClass' : 'removeClass'](
            'm2g-order-section--fade'
        );

        if (is_faded) {
            this.ensureSectionUnfades();
        }
    },
    unfade() {
        this.fade(false);
    },
    ensureSectionUnfades() {
        clearTimeout(this.ensureSectionUnfadesTimeout);
        this.ensureSectionUnfadesTimeout = setTimeout(() => {
            this.unfade();
        }, 3600);
    },
    complete(is_complete) {
        this.$element[is_complete ? 'addClass' : 'removeClass'](
            'm2g-order-section--complete'
        );

        this.$element.removeClass('m2g-order-section--warning');
    },
});
